document.querySelectorAll('.cart-btn').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const targetElement = document.querySelector('[data-add-to-cart]');
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
});

function updateBadgeVisibility() {
  document.querySelectorAll('.selector-wrapper--color input').forEach(input => {
    // Get the badge div
    const badge = document.querySelector('.limited-edition-badge');

    if (badge) {
      // Show the badge if the value contains "Limited Edition", otherwise hide it
      if (input.value.includes('Limited Edition')) {
        badge.style.display = 'block'; // Show the badge
      } else {
        badge.style.display = 'none'; // Hide the badge
      }
    }
  });
}

// Set up event listener for change event
document.querySelectorAll('.selector-wrapper--color input').forEach(input => {
  input.addEventListener('change', updateBadgeVisibility);
});

// Call the function on page load
document.addEventListener('DOMContentLoaded', updateBadgeVisibility);







